<template>
  <div id="displayproduct" class="d-flex flex-column align-center">
    <v-container>
      <v-row v-if="loading">
        <v-col cols="12" class="d-flex align-center justify-center pa-4 pb-6">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <div
        v-else-if="!selectedProduct"
        class="d-flex align-center justify-center pa-4"
      >
        <span
          >This product isn't currently available please naviagate to the home
          or resources page to view all available products..</span
        >
      </div>
      <div v-else>
        <v-card-actions class="justify-space-between pb-0" style="gap: 12px">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="back"
                color="secondary"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </template>
            <span>{{ $i18n.t("movement.back") }}</span>
          </v-tooltip> -->

          <v-breadcrumbs :items="selectedProductBreadCrumbs"></v-breadcrumbs>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                @click="shareProduct(selectedProductSEO)"
              >
                <v-icon>mdi-share</v-icon>
              </v-btn>
            </template>
            <span>{{ $i18n.t("actions.share") }}</span>
          </v-tooltip>
        </v-card-actions>

        <v-row no-gutters>
          <v-col :cols="screenWidth >= 800 ? '7' : '12'" class="pa-6">
            <MediaGallery
              v-if="
                selectedProduct.displayItems &&
                selectedProduct.displayItems.length > 0
              "
              :key="selectedProduct.id"
              :items="selectedProduct.displayItems"
              :aspect-ratio="1"
              :thumb-size="64"
              :max-stage-height="450"
              :video-controls="true"
              :video-autoplay="false"
              :video-loop="true"
              active-color="#ffa9b8"
              hover-color="#fae472"
            />
          </v-col>

          <v-col :cols="screenWidth >= 800 ? '5' : '12'" class="pa-6">
            <v-card-title class="px-0 pt-0 pb-2">
              <h1 class="text-h5 font-weight-bold" style="word-break: normal">
                {{ selectedProduct.title }}
              </h1>
            </v-card-title>
            <v-card-subtitle
              class="pa-0 pt-2"
              v-if="computeSelectedProductCategory() !== ''"
            >
              {{ $i18n.t("headings.category") }}:
              <span class="grey--text">{{
                computeSelectedProductCategory()
              }}</span>
            </v-card-subtitle>
            <v-card-subtitle
              class="px-0 py-1"
              v-if="computeSelectedProductTags() !== ''"
            >
              {{ $i18n.t("labels.tags") }}:
              <span class="grey--text">{{ computeSelectedProductTags() }}</span>
            </v-card-subtitle>
            <span
              v-if="productBundleShowContent"
              class="font-weight-bold primary--text mt-1"
              style="font-family: 'Delight', sans-serif; font-size: 1.3rem"
              >{{ $i18n.t("headings.showBundleContent") }}</span
            >
            <v-btn
              v-if="productShowContent"
              color="primary"
              :disabled="gettingProductContent"
              :loading="gettingProductContent"
              @click="showProductContentDialog"
              block
              class="mt-1"
            >
              {{ $i18n.t("actions.show") + " " + $i18n.t("headings.content") }}
            </v-btn>
            <div
              v-if="productBuyable"
              class="d-flex flex-column text-center"
              style="gap: 8px"
            >
              <div
                class="primary--text font-weight-medium"
                v-html="selectedProductPrice"
              ></div>
              <v-btn
                color="primary"
                @click="attemptBuyProduct(selectedProduct)"
                block
                :loading="savingProductToCart || !ordersSyncedOrSignedOut"
                :disabled="
                  productExistsOnPendingOrder ||
                  offline ||
                  !ordersSyncedOrSignedOut
                "
                >{{ $i18n.t("products.buyNow") }}
              </v-btn>
            </div>

            <v-card-subtitle class="px-0 py-3">
              Resource Use Disclaimer:
              <span class="grey--text"
                >Juffrou Anri resources are designed to support teaching and
                learning. They are provided as professional support materials
                and are not positioned as secure, ready-to-administer classroom
                or assessment instruments. Educators and caregivers remain
                responsible for determining whether, how, and in what context
                resources are used, in accordance with their learners’ needs,
                school policies, and applicable educational guidelines.</span
              >
            </v-card-subtitle>

            <div v-if="selectedProduct.products">
              <p class="text-subtitle-2 my-4">
                {{ $i18n.t("headings.products") }}
              </p>
              <v-row style="gap: 8px" no-gutters class="mb-2">
                <v-chip
                  v-for="(bundleProduct, pIndex) in selectedProduct.products"
                  :key="pIndex"
                  color="primary"
                  class="text-wrap py-1"
                  @click="viewBundleProduct(bundleProduct.id)"
                  style="height: fit-content"
                  >{{ bundleProduct.title }}</v-chip
                ></v-row
              >
            </div>
          </v-col>

          <v-col :cols="screenWidth >= 800 ? '7' : '12'" class="px-6 pb-6">
            <v-expansion-panels
              flat
              v-if="selectedProduct.description"
              v-model="selectedProductDescriptionPanel"
            >
              <v-expansion-panel>
                <v-expansion-panel-header class="text-subtitle-2 pl-0">{{
                  $i18n.t("headings.product") + " " + $i18n.t("labels.details")
                }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div
                    class="pt-2 tiptap"
                    v-html="selectedProduct.description"
                  ></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-dialog
      persistent
      v-if="physicalQuestionsDialog"
      v-model="physicalQuestionsDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <span class="text-h4">Product Questions</span>
        </v-card-title>

        <v-form
          ref="productQuestionsForm"
          v-model="validQuestions"
          @submit.prevent="addToCart"
        >
          <v-row class="ma-4 flex-column">
            <template
              v-for="(question, questionIndex) in selectedProduct.questions"
            >
              <v-text-field
                v-if="question.type === 'Text'"
                :key="'text-' + questionIndex"
                v-model="question.value"
                :label="question.label"
                :hint="question.hint"
                :placeholder="question.placeholder"
                @dblclick="copyPlaceholderToValue(question)"
                :required="question.required"
                :rules="question.required ? formRules.required : []"
              ></v-text-field>
              <v-textarea
                v-if="question.type === 'Textarea'"
                :key="'textarea-' + questionIndex"
                v-model="question.value"
                :label="question.label"
                :hint="question.hint"
                :placeholder="question.placeholder"
                @dblclick="copyPlaceholderToValue(question)"
                auto-grow
                :required="question.required"
                :rules="question.required ? formRules.required : []"
              ></v-textarea>
              <v-select
                v-if="
                  question.type === 'Select' || question.type === 'Multi Select'
                "
                :key="'select-' + questionIndex"
                v-model="question.value"
                :label="question.label"
                :items="question.items"
                :hint="question.hint"
                :placeholder="question.placeholder"
                :multiple="question.type === 'Multi Select'"
                :required="question.required"
                :rules="question.required ? formRules.required : []"
              ></v-select>
              <v-radio-group
                v-if="question.type === 'Radio'"
                :key="'radio-' + questionIndex"
                v-model="question.value"
                :label="question.label"
                :hint="question.hint"
                :rules="question.required ? formRules.required : []"
              >
                <v-radio
                  v-for="(item, itemIndex) in question.items"
                  :key="'item-' + itemIndex"
                  :label="item"
                  :value="item"
                ></v-radio>
              </v-radio-group>
              <div
                v-if="question.type === 'Checkbox'"
                :key="'checkbox-container-' + questionIndex"
              >
                <span class="v-label">{{ question.label }}</span>
                <template>
                  <v-checkbox
                    v-for="(item, itemIndex) in question.items"
                    :key="'checkbox-' + questionIndex + '-' + itemIndex"
                    v-model="question.value"
                    :value="item"
                    :label="item"
                    :rules="question.required ? formRules.required : []"
                  ></v-checkbox>
                </template>
              </div>
            </template>
          </v-row>

          <v-card-actions>
            <v-btn
              color="secondary"
              class="black--text"
              @click="closePhysicalQuestionsDialog"
              >{{ $i18n.t("actions.close") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="addToCart()"
              :loading="savingProductToCart || !ordersSyncedOrSignedOut"
              :disabled="
                productExistsOnPendingOrder ||
                !validQuestions ||
                offline ||
                !ordersSyncedOrSignedOut
              "
              >{{ $i18n.t("products.addToCart") }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-if="addonsDialog"
      v-model="addonsDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <span class="text-h4">Select Addons</span>
        </v-card-title>
        <v-container>
          <v-row class="mx-3 d-flex flex-column">
            <div v-for="(addon, index) in productAddons" :key="index">
              <v-checkbox
                v-model="addon.selected"
                :label="`${addon.type} - ${addon.title} (R${
                  addon.price ? addon.price.toFixed(2) : ''
                })`"
              ></v-checkbox>
            </div>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            color="secondary"
            class="black--text"
            @click="closeAddonsDialog"
            >{{ $i18n.t("actions.cancel") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmAddons">{{
            $i18n.t("actions.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="selectedProductContent"
      persistent
      v-model="productContentDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <span class="text-h4">{{
            $i18n.t("headings.product") + " " + $i18n.t("headings.content")
          }}</span>
        </v-card-title>

        <v-row class="ma-0" v-if="!selectedProductContent.message">
          <div
            v-show="selectedProductContent.files.length > 0"
            style="width: 100%"
          >
            <v-card-title class="justify-center pb-0">
              <span class="text-h5">{{ $i18n.t("labels.files") }}</span>
            </v-card-title>
            <div class="pb-1" style="width: 100%">
              <v-col
                cols="12"
                v-for="(file, fileIndex) in selectedProductContent.files"
                :key="fileIndex"
              >
                <v-btn
                  color="primary"
                  @click="downloadFile(file.fileUrl)"
                  block
                  >{{ file.fileName }}</v-btn
                >
              </v-col>
            </div>
          </div>
          <div
            v-show="
              selectedProductContentURLS.normalLinks.length > 0 ||
              selectedProductContentURLS.videoEmbeds.length > 0
            "
            style="width: 100%"
            class="px-3 pb-2"
          >
            <div v-show="selectedProductContentURLS.videoEmbeds.length > 0">
              <v-card-title class="justify-center pb-3">
                <span class="text-h5">{{ $i18n.t("headings.videos") }}</span>
              </v-card-title>

              <div
                v-for="(
                  videoSrc, srcIndex
                ) in selectedProductContentURLS.videoEmbeds"
                :key="'video-' + srcIndex"
              >
                <VideoEmbed :src="videoSrc" />
              </div>
            </div>
            <!-- <div v-show="selectedProductContentURLS.normalLinks.length > 0">
              <v-card-title class="justify-center pb-1">
                <span class="text-h5">{{ $i18n.t("labels.urls") }}</span>
              </v-card-title>
              <ul>
                <li
                  v-for="(
                    url, urlIndex
                  ) in selectedProductContentURLS.normalLinks"
                  :key="'url-' + urlIndex"
                >
                  <a :href="url" target="_blank">{{ url }}</a>
                </li>
              </ul>
            </div> -->
          </div>
        </v-row>

        <v-row v-else justify="center" no-gutters>
          {{ selectedProductContent.message }}
        </v-row>

        <v-card-actions>
          <v-btn
            color="secondary"
            class="black--text"
            @click="closeProductContentDialog"
            >{{ $i18n.t("actions.close") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="sharedSnackbar"
      min-width="auto"
      top
      elevation="10"
      timeout="2000"
      rounded="pill"
      color="secondary"
    >
      <div class="text-center">Product URL copied!</div>
    </v-snackbar>
  </div>
</template>

<script>
import router from "@/router";
import { mapState, mapGetters } from "vuex";
import VideoEmbed from "@/components/global-components/VideoEmbed.vue";
import MediaGallery from "@/components/global-components/MediaGallery.vue";
import {
  DataStore,
  // SortDirection,
  Storage,
  API,
} from "aws-amplify";
import {
  // Product,
  ProductTag,
  ProductCategory,
  // TeacherProductsOrder,
  // ProductBundle,
} from "@/models";
import _ from "lodash";
import store from "@/store";
// import AuthenticatorDialog from "@/core/services/AuthenticatorDialog.vue";
// import Helper from "@/components/global-components/Helper.vue";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";
import { reconfigureDatastore } from "@/plugins/datastore/config.js";
import subjectAccessMixin from "@/mixins/subjectAccessMixin.js";

export default {
  name: "DisplayProduct",
  mixins: [subjectAccessMixin],
  components: {
    VideoEmbed,
    MediaGallery,

    // AuthenticatorDialog,
    // ,Helper
  },

  props: {
    search: {
      type: Boolean,
      required: false,
    },
    featured: {
      type: Boolean,
      required: false,
      default: false,
    },
    productLimit: {
      type: Number,
      required: false,
    },
  },

  data: () => ({
    sharedSnackbar: false,

    showFeatured: false,
    initiallyLoaded: false,
    loading: false,
    hoverIndex: -1,
    currentDateTime: new Date().toISOString(),

    validQuestions: false,

    syncedProductBundles: false,

    // productSubscription: null,
    syncedProductArray: [],
    syncedProductBundleArray: [],
    products: [],

    queriedProduct: false,
    syncedProducts: false,

    loadedProductThumbnails: [],
    savingProductToCart: false,
    pendingSaveProductToCart: false,

    syncedProductTagArray: [],
    // tagSubscription: null,

    syncedProductCategoryArray: [],
    // syncedSubscribedCategoryIDArray: [],
    // categorySubscription: null,
    routeCategory: null,
    routeCategoryArray: [],
    mainCategories: [],

    gettingProductContent: false,

    selectingProduct: false,

    selectedProductSEO: null,
    selectedProduct: null,

    selectedProductContent: null,
    selectedProductDescriptionPanel: 0,

    productContentDialog: false,
    // authenticatorDialog: false,
    physicalQuestionsDialog: false,

    addonsDialog: false,
    productAddons: [],
    chosenAddons: [],

    productsSearch: "",
    productsSearchTags: [],
    productsSearchCategories: [],
    viewMySubscribedProducts: false,
    viewMyBoughtProducts: false,

    productsDataStoreLimit: 4,

    searchProductCategoriesMenu: false,

    formRules: {
      required: [(v) => !!v || "Required"],
    },
  }),

  computed: {
    ...mapState({
      offline: (state) => !state.isOnline,
      syncedTeacherProfile: (state) => state.syncedTeacherProfile,
      syncedTeacherProductsOrders: (state) => state.syncedTeacherProductsOrders,
      teacherProfilePayfastSubscriptionResponse: (state) =>
        state.teacherProfilePayfastSubscriptionResponse,

      syncedTeacherProfileModel: (state) => state.syncedTeacherProfileModel,
      syncedTeacherProductsOrderModels: (state) =>
        state.syncedTeacherProductsOrderModels,

      syncedPendingTeacherProductsOrder: (state) =>
        state.syncedPendingTeacherProductsOrder,

      guestCart: (state) => state.guestCart,

      syncedBoughtProducts: (state) => state.syncedBoughtProducts,
      // syncedPendingProducts: (state) => state.syncedPendingProducts,

      teacherProfileID: (state) => state.teacherProfileID,
      userGroups: (state) => state.userGroups,
      userSignedIn: (state) => state.userSignedIn,
      datastorePredicates: (state) => state.datastorePredicates,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
      datastoreReady: (state) => state.datastoreReady,
      startedDatastoreSync: (state) => state.startedDatastoreSync,
    }),

    ...mapGetters(["pendingProducts"]),

    ordersSyncedOrSignedOut() {
      return this.syncedTeacherProductsOrders || !this.userSignedIn;
    },

    authMode() {
      return this.userSignedIn ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM";
    },

    selectedProductContentURLS() {
      const urls =
        this.selectedProductContent?.urls?.length > 0
          ? this.selectedProductContent.urls
          : [];

      const youtubeRegex = /^[a-zA-Z0-9_-]{11}$/; // Matches YouTube video IDs (11-character alphanumeric)
      const vimeoRegex = /^[0-9]+$/; // Matches Vimeo video IDs (only numbers)

      const videoEmbeds = [];
      const normalLinks = [];

      urls.forEach((link) => {
        if (youtubeRegex.test(link) || vimeoRegex.test(link)) {
          videoEmbeds.push(link);
        } else {
          normalLinks.push(link);
        }
      });

      return { videoEmbeds, normalLinks };
    },

    selectedProductBreadCrumbs() {
      let breadcrumbs = [
        {
          text: this.$i18n.t("headings.home").toUpperCase(),
          disabled: false,
          href: "/",
        },
      ];

      const parentCategories =
        this.computeSelectedProductParentCategories() || [];
      console.log("parentCategories", parentCategories);

      parentCategories.forEach((category) => {
        breadcrumbs.push({
          text: category.name.toUpperCase(),
          disabled: false,
          href: `/category/${category.id}`,
        });
      });

      return breadcrumbs;
    },

    selectedProductPrice() {
      return this.selectedProduct.price &&
        this.selectedProduct.discountPercentage
        ? `<del>R${(this.selectedProduct.price || 0).toFixed(2)}</del> R` +
            (
              (this.selectedProduct.price || 0) -
              (this.selectedProduct.price || 0) *
                (this.selectedProduct.discountPercentage / 100)
            ).toFixed(2)
        : (this.selectedProduct.price || 0)
        ? "R" + (this.selectedProduct.price || 0).toFixed(2)
        : "FREE";
      // return this.selectedProduct.price
      //   ? this.selectedProduct.price.toFixed(2)
      //   : 0;
    },

    selectedProductVat() {
      return `Price incl. VAT (15%) ${Number.parseFloat(
        this.selectedProduct.price
          ? this.selectedProduct.price - this.selectedProduct.price / 1.15
          : 0,
      ).toFixed(2)}`;
    },

    screenWidth() {
      let width = this.$vuetify.breakpoint.width;
      return width;
    },

    computedProductCategoryArray: {
      get: function () {
        return this.syncedProductCategoryArray.map((category) => {
          let parentCategories = [];

          if (category.parentId) {
            let currentCategory = category;
            while (currentCategory.parentId) {
              const parentCategory = this.syncedProductCategoryArray.find(
                (category) => category.id === currentCategory.parentId,
              );
              if (parentCategory) {
                parentCategories.unshift(parentCategory.name);
                currentCategory = parentCategory;
              } else {
                break;
              }
            }
          }

          return parentCategories?.length > 0
            ? parentCategories.join("/") + "/" + category.name
            : category.name;
        });
      },
    },

    computedProductsSearchCategories: {
      get: function () {
        let categories = [];
        _.forEach(this.productsSearchCategories, (categoryId) => {
          const category = _.find(this.syncedProductCategoryArray, {
            id: categoryId,
          });
          if (category) {
            let parentCategories = [];

            if (category.parentId) {
              let currentCategory = category;
              while (currentCategory.parentId) {
                const parentCategory = this.syncedProductCategoryArray.find(
                  (category) => category.id === currentCategory.parentId,
                );
                if (parentCategory) {
                  parentCategories.unshift(parentCategory.name);
                  currentCategory = parentCategory;
                } else {
                  break;
                }
              }
            }

            categories.push(
              parentCategories?.length > 0
                ? parentCategories.join("/") + "/" + category.name
                : category.name,
            );
          }
        });
        return categories;
      },
      // set: function (newValue) {
      //   let categoryIds = [];
      //   if (newValue.length > 0) {
      //     for (const category of newValue) {
      //       const categoryParts = category.split("/");
      //       const newCategory = categoryParts[categoryParts.length - 1];

      //       if (typeof newCategory === "string" && newCategory !== "") {
      //         const category = this.syncedProductCategoryArray.find(
      //           (category) => category.name === newCategory
      //         );

      //         if (category) categoryIds.push(category.id);
      //       }
      //     }

      //     this.productsSearchCategories = categoryIds;
      //   } else {
      //     this.productsSearchCategories = [];
      //   }
      // },
    },

    computedProductsSearchTags: {
      get: function () {
        let tags = [];
        _.forEach(this.productsSearchTags, (tagId) => {
          const productTag = _.find(this.syncedProductTagArray, { id: tagId });
          if (productTag) {
            tags.push(productTag);
          }
        });
        return tags;
      },
      set: function (newValue) {
        this.productsSearchTags = newValue;
      },
    },

    productExistsOnPendingOrder() {
      if (!this.selectedProduct) return false;

      const productId = this.selectedProduct.id;
      return this.pendingProducts.some((id) => id === productId);
    },

    // Check if a product is bought or subscribed
    isProductBoughtOrSubscribed() {
      if (!this.selectedProduct) return false;
      const { id } = this.selectedProduct;
      return this.syncedBoughtProducts?.includes(id) ||
        this.hasSchoolAccess(id) ||
        this.syncedTeacherProfileModel?.productSubscriptions?.some(
          (subscription) => subscription.productId === id,
        )
        ? true
        : false;
    },

    // Check if the product's download limit is reached
    productAddToMyLibrary() {
      const { id, subscriptionProduct } = this.selectedProduct;
      return subscriptionProduct &&
        !this.isProductBoughtOrSubscribed &&
        !this.downloadLimitReached(this.selectedProduct) &&
        this.subscribedToGrade(this.selectedProduct.categoryId) &&
        (this.teacherProfilePayfastSubscriptionResponse?.status_text ===
          "ACTIVE" ||
          this.teacherProfilePayfastSubscriptionResponse
            ?.subscriptionStillValid)
        ? true
        : false;
    },

    // Check if download limit for the product is reached
    productDownloadLimitReached() {
      const { id, subscriptionProduct } = this.selectedProduct;
      return subscriptionProduct &&
        !this.isProductBoughtOrSubscribed &&
        this.downloadLimitReached(this.selectedProduct)
        ? true
        : false;
    },

    // Check if subscription to grade is needed to download
    productSubToGradeToDownload() {
      const { id, subscriptionProduct, categoryId } = this.selectedProduct;
      return subscriptionProduct &&
        !this.isProductBoughtOrSubscribed &&
        !this.subscribedToGrade(categoryId)
        ? true
        : false;
    },

    // Check if content should be shown
    productShowContent() {
      return this.isProductBoughtOrSubscribed && !this.selectedProduct.products
        ? true
        : false;
    },

    // Check if bundle content should be shown
    productBundleShowContent() {
      return this.isProductBoughtOrSubscribed && this.selectedProduct.products
        ? true
        : false;
    },

    // Check if product can be subscribed
    productSubscribable() {
      return this.selectedProduct?.subscriptionProduct ? true : false;
    },

    // Check if the product is buyable
    productBuyable() {
      const {
        id,
        // , eCommerceProduct
      } = this.selectedProduct;
      return (
        // eCommerceProduct &&
        !this.productAddToMyLibrary && !this.isProductBoughtOrSubscribed
          ? true
          : false
      );
    },

    // filteredProducts() {
    //   let products = this.products;
    //   if (this.routeCategory) {
    //     products = products.filter((product) =>
    //       this.routeCategoryArray.includes(product.categoryId)
    //     );
    //   }
    //   if (this.showFeatured) {
    //     products = products.filter((product) => product.featured);
    //   }

    //   const sortedProducts = _.sortBy(products, [
    //     (p) => p.featured || false,
    //     (p) => new Date(p.publishDate),
    //     (p) => p.title,
    //   ]).reverse();

    //   return sortedProducts.slice(0, this.productsDataStoreLimit);
    // },
  },

  mounted() {
    try {
      // console.log("mounted DisplayProduct");

      this.showFeatured = this.featured ? this.featured : false;

      this.productsDataStoreLimit = this.productLimit ? this.productLimit : 4;

      if (router.currentRoute.path.includes("subscribed-products")) {
        this.viewMySubscribedProducts = true;
      } else if (router.currentRoute.path.includes("bought-products")) {
        this.viewMyBoughtProducts = true;
      }

      const varUserSignedIn = this.userSignedIn;

      store.commit("changeDatastorePredicates", [
        // {
        //   model: "Product",
        //   predicate: "RouteSpecific",
        // },
        {
          model: "ProductTag",
          predicate: varUserSignedIn ? "Teacher" : "Public",
        },
        {
          model: "ProductCategory",
          predicate: varUserSignedIn ? "Teacher" : "Public",
        },
        // {
        //   model: "ProductBundle",
        //   predicate: "RouteSpecific",
        // },
      ]);

      if (!this.startedDatastoreSync || this.datastoreReady) {
        reconfigureDatastore();
      }

      if (!this.changingDatastoreConfig) {
        // if (router.currentRoute.params?.categoryId) {
        //   const categories = await DataStore.query(ProductCategory);

        //   const sortedItemsViaName = categories.sort((a, b) =>
        //     a.name.localeCompare(b.name)
        //   );

        //   this.syncedProductCategoryArray = sortedItemsViaName;

        //   this.mainCategories = sortedItemsViaName.filter(
        //     (category) => !category.parentId
        //   );

        //   await this.queryRouteCategory();
        // } else {
        //   await this.changeProductsSearchQuery();
        // }

        this.syncData();
      }

      // Load product on mount using seoId
      this.loadProduct();
    } catch (error) {
      console.log(error);
    }
    // finally {
    //   if (!this.initiallyLoaded) {
    //     this.initiallyLoaded = true;
    //   }
    // }
  },

  watch: {
    changingDatastoreConfig: {
      handler(newVal, oldVal) {
        // console.log("watch changingDatastoreConfig", newVal, oldVal);

        if (newVal === false) {
          this.syncData();
        }
      },
      // deep: true,
    },

    syncedTeacherProfileModel: {
      handler: async function (val) {
        if (
          val &&
          this.pendingSaveProductToCart &&
          this.syncedTeacherProductsOrders &&
          !this.offline
        ) {
          // console.log(
          //   "syncedTeacherProfileModel",
          //   this.syncedTeacherProfileModel
          // );
          await this.attemptBuyProductQuestions(this.selectedProduct);

          this.pendingSaveProductToCart = false;
          // await this.buyProduct(this.selectedProduct);
        }
      },
      deep: true,
    },

    syncedTeacherProductsOrders: {
      handler: async function (val) {
        if (
          val &&
          this.pendingSaveProductToCart &&
          this.syncedTeacherProfileModel &&
          !this.offline
        ) {
          // console.log(
          //   "syncedTeacherProductsOrders",
          //   this.syncedTeacherProductsOrders
          // );
          await this.attemptBuyProductQuestions(this.selectedProduct);

          this.pendingSaveProductToCart = false;
          // await this.buyProduct(this.selectedProduct);
        }
      },
      deep: true,
    },

    isProductBoughtOrSubscribed: {
      async handler() {
        if (!this.selectedProductContent && !this.gettingProductContent) {
          // Reload product to update UI
          await this.getProductContent();
        }
      },
    },

    // "$route.params": {
    //   handler(newVal, oldVal) {
    //     console.log("newVal", newVal);
    //     console.log("oldVal", oldVal);

    //     // if (typeof newVal !== "object") return;

    //   },
    // },

    $route(to, from) {
      console.log("$route", to, from);
      if (to.params.pathMatch !== from.params.pathMatch) {
        this.loadProduct();
      }
    },
  },

  methods: {
        parseAddons(addons) {
      if (!addons) return [];
      if (typeof addons === "string") {
        try {
          const parsed = JSON.parse(addons);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return Array.isArray(addons) ? addons : [];
    },

    async confirmAddons() {
      this.chosenAddons = this.productAddons
        .filter((addon) => addon.selected)
        .map(({ selected, ...addon }) => addon);

      this.addonsDialog = false;
      this.productAddons = [];

      if (this.selectedProduct.questions?.length > 0) {
        this.physicalQuestionsDialog = true;
      } else {
        await this.buyProduct(this.selectedProduct, this.chosenAddons);
        this.chosenAddons = [];
      }
    },

    closeAddonsDialog() {
      this.addonsDialog = false;
      this.productAddons = [];
      this.chosenAddons = [];
    },

    async getVimeoThumbnail(videoId) {
      try {
        const response = await fetch(
          `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`,
        );
        const data = await response.json();
        return data.thumbnail_url;
      } catch (error) {
        console.error("Error fetching Vimeo thumbnail:", error);
        return null;
      }
    },

    getYouTubeThumbnail(videoId) {
      return `https://img.youtube.com/vi/${videoId}/0.jpg`;
    },

    async loadProduct() {
      const pathMatch = this.$route.params.pathMatch;
      if (!pathMatch) return;

      console.log("pathMatch:", pathMatch);
      this.loading = true;
      this.selectedProduct = null;

      try {
        // Check if pathMatch is a valid UUID
        const isValidUUID =
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
            pathMatch,
          );

        console.log("isValidUUID:", isValidUUID);

        let product;
        let productSEO;
        if (isValidUUID) {
          // Direct product query if pathMatch is a valid UUID
          const productResponse = await API.graphql({
            query: queries.getProduct,
            variables: { id: pathMatch },
            authMode: this.authMode,
          });

          if (productResponse.data.getProduct?.id) {
            const seoResponse = await API.graphql({
              query: queries.productSEOSByProductID,
              variables: { productID: pathMatch },
              authMode: this.authMode,
            });
            productSEO = seoResponse.data.productSEOSByProductID.items[0];
            product = productResponse.data.getProduct;
          } else {
            const productBundleResponse = await API.graphql({
              query: queries.getProductBundle,
              variables: { id: pathMatch },
              authMode: this.authMode,
            });

            const seoResponse = await API.graphql({
              query: queries.productSEOSByProductBundleID,
              variables: { productBundleID: pathMatch },
              authMode: this.authMode,
            });
            productSEO = seoResponse.data.productSEOSByProductBundleID.items[0];
            product = productBundleResponse.data.getProductBundle;
          }
        } else {
          const seoId = this.$route.path.slice(1);
          const seoResponse = await API.graphql({
            query: queries.productSEOSBySeoId,
            variables: { seoId: seoId },
            authMode: this.authMode,
          });
          productSEO = seoResponse.data.productSEOSBySeoId.items[0];
          this.selectedProductSEO = productSEO;

          const productOrBundleId = productSEO.productID
            ? productSEO.productID
            : productSEO.productBundleID;

          const productResponse = await API.graphql({
            query: productSEO.productID
              ? queries.getProduct
              : queries.getProductBundle,
            variables: { id: productOrBundleId },
            authMode: this.authMode,
          });

          product =
            productResponse.data.getProduct ||
            productResponse.data.getProductBundle;
        }

        if (product?.products) {
          product.products = JSON.parse(product.products);
        }
        console.log("product:", product);

        if (product) {
          this.selectedProductSEO = productSEO;
          this.selectedProduct = {
            ...product,
            thumbnailImages: [],
            displayItems: [],
          };

          // Load thumbnail images
          if (this.selectedProduct.thumbnails?.length > 0) {
            this.selectedProduct.thumbnailImages = await Promise.all(
              this.selectedProduct.thumbnails.map(async (thumbnailKey) => {
                return await Storage.get(thumbnailKey, { level: "public" });
              }),
            );
          }

          // Build displayItems array
          if (this.selectedProduct.thumbnailImages.length > 0) {
            this.selectedProduct.displayItems =
              this.selectedProduct.thumbnailImages.map((src, index) => ({
                type: "image",
                src,
              }));
          }

          if (this.selectedProduct.videoPreview) {
            const platform = /^[0-9]+$/.test(this.selectedProduct.videoPreview)
              ? "vimeo"
              : "youtube";
            let thumbnailUrl;
            if (platform === "youtube") {
              thumbnailUrl = this.getYouTubeThumbnail(
                this.selectedProduct.videoPreview,
              );
            } else if (platform === "vimeo") {
              thumbnailUrl = await this.getVimeoThumbnail(
                this.selectedProduct.videoPreview,
              );
            }
            if (thumbnailUrl) {
              this.selectedProduct.displayItems.push({
                type: "video",
                src: this.selectedProduct.videoPreview,
                thumbnail: thumbnailUrl,
              });
            }
          }
        } else {
          console.error("Product not found for pathMatch:", pathMatch);
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        this.initiallyLoaded = true;
        this.loading = false;
      }
    },

    back() {
      console.log(this.$router);
      console.log(
        "this.$router.options.history?.state?.back:",
        this.$router.options.history?.state?.back,
      );
      if (window.history.length > 1) {
        this.$router.back(); // Go back in the browser history
      } else {
        // Fallback route based on user authentication
        this.$router.push({
          path: this.userSignedIn ? "/app/products" : "/",
        });
      }
    },

    shareProduct(productSEO) {
      const shareUrl = `${window.location.origin}/${productSEO.seoId}`;

      // Use the Web Share API to share a message, image, and URL
      if (navigator.share) {
        navigator
          .share({
            // title: heading,
            // text: message,
            url: shareUrl,
          })
          .then(() => {
            // console.log("Shared successfully.")
          })
          .catch(() => {
            // console.error("Error sharing:", error)
          });

        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(shareUrl).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      } else {
        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(shareUrl).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      }

      this.sharedSnackbar = true;
    },

    viewBundleProduct(bundleProductId) {
      const currentRoutePath = router.currentRoute.path;

      if (!currentRoutePath.includes(bundleProductId)) {
        router.push(`/product/${bundleProductId}`).catch(() =>
          // error
          {
            // console.log(error);
          },
        );
      }
    },

    productPrice(price, discountPercentage) {
      // console.log("price:", price, "discountPercentage:", discountPercentage);
      return price && discountPercentage
        ? `<del>R${(price || 0).toFixed(2)}</del> R` +
            ((price - price * (discountPercentage / 100)) || 0).toFixed(2)
        : (price || 0).toFixed(2)
        ? "R" + (price || 0).toFixed(2)
        : "FREE";
    },

    copyPlaceholderToValue(question) {
      if (!question.value && question.placeholder) {
        question.value = question.placeholder;
      }
    },

    attemptBuyProductQuestions(selectedProduct) {
      const alreadyOwnsProduct =
        this.syncedBoughtProducts?.includes(selectedProduct.id) ||
        this.hasSchoolAccess(selectedProduct.id) ||
        this.syncedTeacherProfileModel?.productSubscriptions?.some(
          (subscription) => subscription.productId === selectedProduct.id,
        );
      const alreadyPendingProduct = this.pendingProducts.some(
        (id) => id === selectedProduct.id,
      );

      // Normalize questions: it may come back as a JSON string like "[]"
      selectedProduct.questions = !selectedProduct.questions
        ? []
        : typeof selectedProduct.questions === "string"
        ? JSON.parse(selectedProduct.questions)
        : selectedProduct.questions;

      if (alreadyOwnsProduct || alreadyPendingProduct) {
        this.buyProduct(selectedProduct);
        return;
      }

      const addons = this.parseAddons(selectedProduct.addons);
      this.chosenAddons = [];

      if (addons.length > 0) {
        this.productAddons = addons.map((addon) => ({
          ...addon,
          selected: false,
        }));
        this.addonsDialog = true;
      } else if (selectedProduct.questions.length > 0) {
        this.physicalQuestionsDialog = true;
      } else {
        this.buyProduct(selectedProduct, []);
      }
    },

    async addToCart() {
      try {
        await this.buyProduct(this.selectedProduct, this.chosenAddons);
      } catch (error) {
        console.log(error);
      }

      this.physicalQuestionsDialog = false;
      this.validQuestions = false;
      this.chosenAddons = [];
    },

    async attemptBuyProduct(selectedProduct) {
      // if (this.syncedTeacherProfileModel) {
      // await this.buyProduct(selectedProduct);
      await this.attemptBuyProductQuestions(selectedProduct);
      // } else {
      //   this.pendingSaveProductToCart = true;
      //   // this.authenticatorDialog = true;
      //   await router.push(`/app/products/${selectedProduct.id}/buy`).catch(() =>
      //     // error
      //     {
      //       // console.log(error);
      //     },
      //   );
      // }
    },

    generateOrderID() {
      const now = new Date();
      const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hour = now.getHours().toString().padStart(2, "0");
      const minute = now.getMinutes().toString().padStart(2, "0");
      const second = now.getSeconds().toString().padStart(2, "0");
      const millisecond = Math.floor(now.getMilliseconds() / 10)
        .toString()
        .padStart(2, "0");
      return `${year}${month}${day}-${hour}${minute}${second}${millisecond}`;
    },

    async buyProduct(selectedProduct, chosenAddons = []) {
      this.savingProductToCart = true;

      if (
        this.syncedBoughtProducts?.includes(selectedProduct.id) ||
        this.hasSchoolAccess(selectedProduct.id) ||
        this.syncedTeacherProfileModel?.productSubscriptions?.some(
          (subscription) => subscription.productId === selectedProduct.id,
        )
      ) {
        await this.getProductContent();
        this.savingProductToCart = false;
        return;
      }

      // const queriedItems = await DataStore.query(TeacherProductsOrder, (item) =>
      //   item.orderStatus("eq", "PENDING")
      // );
      // // console.log("queriedItems", queriedItems);

      // const pendingTeacherProductsOrder = _.find(queriedItems, {
      //   orderStatus: "PENDING",
      // });

      const newProduct = _.cloneDeep(selectedProduct);

      // Only the addons the customer picked go on the cart line,
      // never the product's full catalog addon list.
      newProduct.addons = chosenAddons;

      if (newProduct.thumbnailImages) delete newProduct.thumbnailImages;
      if (newProduct.searchField) delete newProduct.searchField;
      if (newProduct.description) delete newProduct.description;
      if (newProduct.displayItems) delete newProduct.displayItems;
      if (newProduct.createdAt) delete newProduct.createdAt;
      if (newProduct.updatedAt) delete newProduct.updatedAt;
      if (newProduct.featured) delete newProduct.featured;
      if (newProduct.thumbnails) delete newProduct.thumbnails;
      if (newProduct.type) delete newProduct.type;
      if (newProduct.videoPreview) delete newProduct.videoPreview;
      if (newProduct._lastChangedAt) delete newProduct._lastChangedAt;
      if (newProduct.__typename) delete newProduct.__typename;

      if (!this.userSignedIn) {
        const newProductsOrderArray =
          this.guestCart?.orderProducts?.length > 0
            ? [...this.guestCart.orderProducts, newProduct]
            : [newProduct];

        const uniqueProducts = _.uniqBy(newProductsOrderArray, "id");

        this.$store.commit("storeProductsToGuestCart", uniqueProducts);
        // this.openCartDialog(); // optional – opens cart immediately for guest
        this.savingProductToCart = false;
        return;
      }

      const pendingTeacherProductsOrder =
        this.syncedPendingTeacherProductsOrder;

      if (pendingTeacherProductsOrder) {
        if (
          pendingTeacherProductsOrder.orderProducts?.some(
            (product) => product.id === selectedProduct.id,
          )
        ) {
          // console.log("Product already added to the pending order.");
          this.savingProductToCart = false;
          return;
        }

        const newProductsOrderArray =
          pendingTeacherProductsOrder.orderProducts?.length > 0
            ? [...pendingTeacherProductsOrder.orderProducts, newProduct]
            : [newProduct];

        const uniqueProducts = _.uniqBy(newProductsOrderArray, "id");

        // await DataStore.save(
        //   TeacherProductsOrder.copyOf(
        //     pendingTeacherProductsOrder,
        //     (updateModel) => {
        //       updateModel.orderProducts = uniqueProducts;
        //     }
        //   )
        // );

        const teacherProductsOrderDetails = {
          id: pendingTeacherProductsOrder.id,
          _version: pendingTeacherProductsOrder._version, // add the "_version" field if your AppSync API has conflict detection (required for DataStore) enabled
          orderProducts: JSON.stringify(uniqueProducts),
          updatedAtMonth: new Date().toISOString().slice(0, 7),
        };

        const updatedTPO = await API.graphql({
          query: mutations.updateTeacherProductsOrder,
          variables: {
            input: teacherProductsOrderDetails,
          },
          authMode: this.authMode,
        }).catch((error) => {
          // console.log("error:", error);
        });

        // console.log("updatedTPO:", updatedTPO);

        if (updatedTPO?.data?.updateTeacherProductsOrder) {
          store.commit("storePendingTeacherProductsOrder", {
            ...updatedTPO.data.updateTeacherProductsOrder,
            orderProducts: uniqueProducts,
          });
        }
      } else {
        // await DataStore.save(
        //   new TeacherProductsOrder({
        //     orderProducts: [newProduct],
        //     orderStatus: "PENDING",
        //     teacherprofileID: this.teacherProfileID,
        //   })
        // );

        const newOrderID = this.generateOrderID();
        const newOrderMonth = new Date().toISOString().slice(0, 7);

        const teacherProductsOrderDetails = {
          orderProducts: JSON.stringify([newProduct]),
          orderStatus: "PENDING",
          orderID: newOrderID,
          teacherprofileID: this.teacherProfileID,
          createdAtMonth: newOrderMonth,
          updatedAtMonth: newOrderMonth,
        };

        const newTPO = await API.graphql({
          query: mutations.createTeacherProductsOrder,
          variables: {
            input: teacherProductsOrderDetails,
          },
          authMode: this.authMode,
        }).catch((error) => {
          // console.log("error:", error);
        });

        // console.log("newTPO:", newTPO);

        if (newTPO?.data?.createTeacherProductsOrder) {
          store.commit("storePendingTeacherProductsOrder", {
            ...newTPO.data.createTeacherProductsOrder,
            orderProducts: [newProduct],
          });
        }
      }

      this.savingProductToCart = false;
    },

    subscribedToGrade(selectedProductCategoryId) {
      if (!selectedProductCategoryId) return false;
      if (
        this.syncedTeacherProfileModel?.payfastSubscriptionPackage
          ?.grandFathered &&
        this.teacherProfilePayfastSubscriptionResponse?.subscriptionStillValid
      )
        return true;

      try {
        const currentCategory = this.syncedProductCategoryArray.find(
          (category) => category.id === selectedProductCategoryId,
        );
        if (!currentCategory) {
          // console.error("Category not found.");
          return false;
        }

        // Get the array of grades from the synced teacher profile model
        const grades =
          this.syncedTeacherProfileModel.payfastSubscriptionPackage.grades;

        if (!currentCategory.grade && grades?.length > 0) {
          return true;
        }

        // Check if the top parent category's grade matches any in the grades array
        return grades.includes(currentCategory.grade);
      } catch (error) {
        // console.error("Error in subscribedToGrade method:", error);
        return false;
      }
    },

    currentMonthLimit() {
      return (
        this.$i18n.t("products.currentMonthLimit") +
        new Date().toLocaleString("default", { month: "long" })
      );
    },

    downloadLimitReached(selectedProduct) {
      if (
        (this.syncedTeacherProfileModel?.payfastSubscriptionPackage
          ?.grandFathered &&
          this.teacherProfilePayfastSubscriptionResponse
            ?.subscriptionStillValid) ||
        !this.syncedTeacherProfileModel?.payfastSubscriptionPackage ||
        this.syncedTeacherProfileModel?.payfastSubscriptionPackage?.limit === -1
      )
        return false;

      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      const foundCategory = _.find(this.syncedProductCategoryArray, {
        id: selectedProduct.categoryId,
      });

      if (!foundCategory || !foundCategory.grade) return false;

      // Filter the subscriptions that match the given grade and have a timestamp within the current month
      const downloadsThisMonth =
        this.syncedTeacherProfileModel?.productSubscriptions?.filter(
          (subscription) => {
            if (
              !subscription.grade ||
              subscription.grade !== foundCategory.grade
            ) {
              return false;
            }

            const timestampDate = new Date(subscription.timeStamp);
            return (
              timestampDate.getFullYear() === currentYear &&
              timestampDate.getMonth() === currentMonth
            );
          },
        );

      // console.log("downloadsThisMonth.length", downloadsThisMonth?.length);
      // console.log(
      //   "limit",
      //   this.syncedTeacherProfileModel.payfastSubscriptionPackage.limit
      // );

      return (
        downloadsThisMonth?.length >=
        this.syncedTeacherProfileModel.payfastSubscriptionPackage.limit
      );
    },

    async loadThumbnail(entries, productId) {
      // console.log("entries:", entries);

      // Find the product using the productId
      const product = this.products.find((p) => p.id === productId);

      if (
        product &&
        !product.thumbnailImages?.length &&
        product.thumbnails?.length
      ) {
        for (let i = 0; i < Math.min(product.thumbnails.length, 2); i++) {
          const thumbnailKey = product.thumbnails[i];
          try {
            const thumbnailImgSrc = await Storage.get(thumbnailKey, {
              level: "public",
            });
            // Using Vue.set to ensure reactivity
            this.$set(product.thumbnailImages, i, thumbnailImgSrc);
          } catch (error) {
            console.log("Error loading thumbnail:", error);
          }
        }
      }
    },

    isImageLoaded(productId, thumbnailImages) {
      return !!thumbnailImages?.length;
    },

    computeSelectedProductCategory() {
      let parentCategories = [];
      if (
        this.selectedProduct.categoryId &&
        this.selectedProduct.categoryId !== ""
      ) {
        let firstCategoryId = this.selectedProduct.categoryId;

        let category = this.syncedProductCategoryArray.find(
          (category) => category.id === firstCategoryId,
        );

        if (!category) return "";

        if (category.parentId) {
          let currentCategory = category;
          while (currentCategory.parentId) {
            const parentCategory = this.syncedProductCategoryArray.find(
              (category) => category.id === currentCategory.parentId,
            );
            if (parentCategory) {
              parentCategories.unshift(parentCategory.name);
              currentCategory = parentCategory;
            } else {
              break;
            }
          }
        }

        return parentCategories?.length > 0
          ? parentCategories.join(" / ") + " / " + category.name
          : category.name;
      } else return "";
    },

    computeSelectedProductParentCategories() {
      let parentCategories = [];
      if (
        this.selectedProduct.categoryId &&
        this.selectedProduct.categoryId !== ""
      ) {
        let firstCategoryId = this.selectedProduct.categoryId;

        let category = this.syncedProductCategoryArray.find(
          (category) => category.id === firstCategoryId,
        );

        if (!category) return "";

        if (category.parentId) {
          let currentCategory = category;
          while (currentCategory) {
            const parentCategory = this.syncedProductCategoryArray.find(
              (category) => category.id === currentCategory.parentId,
            );
            if (parentCategory) {
              parentCategories.unshift(parentCategory);
              currentCategory = parentCategory;
            } else {
              break;
            }
          }
        }

        parentCategories.push(category);
        return parentCategories;
      } else return [];
    },

    computeSelectedProductTags() {
      let tagNames = [];
      if (this.selectedProduct.tags?.length > 0) {
        this.selectedProduct.tags.forEach((tagId) => {
          const tag = this.syncedProductTagArray.find(
            (tag) => tag.id === tagId,
          );
          if (tag) {
            tagNames.push(tag.name);
          }
        });
        return tagNames.length > 0 ? tagNames.join(", ") : "";
      } else return "";
    },

    mouseOverProductThumbnail(index) {
      this.hoverIndex = index;
    },

    mouseOutProductThumbnail() {
      this.hoverIndex = -1;
    },

    closePhysicalQuestionsDialog() {
      this.physicalQuestionsDialog = false;
      this.validQuestions = false;
      this.chosenAddons = [];
    },

    closeProductContentDialog() {
      this.productContentDialog = false;
    },

    showProductContentDialog() {
      this.productContentDialog = true;
    },

    downloadFile(fileUrl) {
      window.open(fileUrl, "_blank");
    },

    async selectProduct(productID) {
      try {
        this.selectingProduct = true;

        let newlySelectedProduct = null;

        newlySelectedProduct = _.cloneDeep(
          this.syncedProductArray.find((product) => product.id === productID) ||
            this.syncedProductBundleArray.find(
              (product) => product.id === productID,
            ),
        );

        if (!newlySelectedProduct) {
          console.log("Product not found.");
          return;
        }

        this.initiallyLoaded = true;

        console.log("newlySelectedProduct", newlySelectedProduct);

        // Fetch rest of thumbnails for the selected product
        const fetchThumbnails = async (thumbnails, startIndex = 0) => {
          return Promise.all(
            thumbnails
              .slice(startIndex)
              .map(
                async (thumbnailKey) =>
                  await Storage.get(thumbnailKey, { level: "public" }),
              ),
          );
        };

        if (newlySelectedProduct.thumbnails?.length > 0) {
          const { thumbnails, thumbnailImages } = newlySelectedProduct;

          if (typeof thumbnailImages === "undefined" || !thumbnailImages) {
            // Initialize and fetch all thumbnails
            newlySelectedProduct.thumbnailImages = [];
            newlySelectedProduct.thumbnailImages = await fetchThumbnails(
              thumbnails,
            );
          } else if (
            thumbnails?.length > 2 &&
            thumbnailImages?.length !== thumbnails.length
          ) {
            // Fetch thumbnails starting from index 2
            const fetchedImages = await fetchThumbnails(thumbnails, 2);
            newlySelectedProduct.thumbnailImages.push(...fetchedImages);
          }
        }

        this.selectedProduct = _.cloneDeep(newlySelectedProduct);

        if (newlySelectedProduct.products) {
          return;
        }

        if (
          this.syncedTeacherProfileModel?.productSubscriptions?.some(
            (subscription) => subscription.productId === productID,
          )
        ) {
          this.saveGetProductContent();
        } else if (this.syncedBoughtProducts?.some((id) => id === productID)) {
          this.getProductContent();
        } else if (this.hasSchoolAccess(productID)) {
          this.getProductContent();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.selectingProduct = false;
      }
    },

    async saveGetProductContent() {
      this.gettingProductContent = true;
      // const ownsProduct = this.syncedTeacherProfileModel.products?.includes(
      //   this.selectedProduct.id
      // );

      const ownsProduct =
        this.syncedTeacherProfileModel.productSubscriptions?.some(
          (subscription) => subscription.productId === this.selectedProduct?.id,
        );

      if (ownsProduct) {
        await this.getProductContent();
      } else if (
        this.teacherProfilePayfastSubscriptionResponse?.status_text ===
          "ACTIVE" ||
        this.teacherProfilePayfastSubscriptionResponse?.subscriptionStillValid
      ) {
        await this.saveProductContent();
      }

      this.gettingProductContent = false;
    },

    async saveProductContent() {
      try {
        // const productIds = this.syncedTeacherProfileModel.products
        //   ? [
        //       ...this.syncedTeacherProfileModel.products,
        //       this.selectedProduct.id,
        //     ]
        //   : [this.selectedProduct.id];

        const foundCategory = _.find(this.syncedProductCategoryArray, {
          id: this.selectedProduct.categoryId,
        });

        let objToPush = {
          productId: this.selectedProduct.id,
          timeStamp: new Date().toISOString(),
        };

        if (foundCategory?.grade > "") {
          objToPush.grade = foundCategory.grade;
        }

        const productSubscriptions = this.syncedTeacherProfileModel
          .productSubscriptions
          ? [
              ...new Set([
                ...this.syncedTeacherProfileModel.productSubscriptions,
                objToPush,
              ]),
            ]
          : [objToPush];

        await API.graphql({
          query: mutations.updateTeacherProfile,
          variables: {
            input: {
              id: this.syncedTeacherProfileModel.id,
              _version: this.syncedTeacherProfileModel._version,
              productSubscriptions: JSON.stringify(productSubscriptions),
            },
          },
          authMode: this.authMode,
        });

        // await DataStore.save(
        //   TeacherProfile.copyOf(
        //     this.syncedTeacherProfileModel,
        //     (updateModel) => {
        //       updateModel.productSubscriptions = productSubscriptions;
        //     },
        //   ),
        // );

        await this.getProductContent();
      } catch (error) {
        console.log(error);
      }
    },

    async getProductContent() {
      try {
        this.gettingProductContent = true;

        if (!this.selectedProduct?.id) {
          this.gettingProductContent = false;
          return;
        }

        const currentProductId = this.selectedProduct.id;

        console.log("Getting product content...");
        await API.get("productcontentapi", "/item", {
          queryStringParameters: {
            productID: currentProductId,
          },
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          // },
        })
          .then(async (response) => {
            if (
              // !this.isProductBoughtOrSubscribed
              currentProductId !== this.selectedProduct.id
            ) {
              // console.log("Newly selected product not bought or subscribed.");
              // console.log("Old productId", currentProductId);
              // console.log("New ProductId", this.selectedProduct.id);

              this.gettingProductContent = false;
              return;
            }

            console.log("Product content response:", response);

            if (
              response.error ||
              (response.data?.files?.length === 0 &&
                response.data?.urls?.length === 0)
            ) {
              this.selectedProductContent = {
                message: this.$i18n.t("products.noContent"),
              };
            } else {
              this.selectedProductContent = _.cloneDeep(response.data);
            }

            this.gettingProductContent = false;
          })
          .catch((error) => {
            console.log(error);
            this.gettingProductContent = false;
          });
      } catch (error) {
        console.log(error);
        this.gettingProductContent = false;
      }
    },

    // async queryProductsAndBundles() {
    //   try {
    //     const queriedProducts = await DataStore.query(Product, (product) =>
    //       product.and((f) => [
    //         f.or((f) => [
    //           f.and((f) => [
    //             f.eCommerceProduct("eq", true),
    //             //HIDE-subscription-17Dec2024

    //             // this.syncedSubscribedCategoryIDArray.map((id) =>
    //             //   f.categoryId("ne", id)
    //             // ),
    //           ]),
    //           f.and((f) => [
    //             f.subscriptionProduct("eq", true),
    //             this.viewMySubscribedProducts
    //               ? this.syncedTeacherProfileModel?.productSubscriptions
    //                   ?.length > 0
    //                 ? f.or((f) =>
    //                     this.syncedTeacherProfileModel.productSubscriptions.map(
    //                       (pS) => f.id("eq", pS.productId)
    //                     )
    //                   )
    //                 : f.id("eq", null)
    //               : f.subscriptionProduct("ne", true),
    //           ]),
    //         ]),
    //         f.thumbnails("gt", []),
    //         f.publishDate("lt", this.currentDateTime),
    //       ])
    //     );

    //     const queriedProductBundles = await DataStore.query(
    //       ProductBundle,
    //       (product) =>
    //         product.and((f) => [
    //           f.thumbnails("gt", []),
    //           f.publishDate("lt", this.currentDateTime),
    //         ])
    //     );

    //     // console.log("Queried products:", queriedProducts);

    //     const queriedItems = [...queriedProducts, ...queriedProductBundles];

    //     // this.syncedProductArray = queriedProducts;

    //     // Loop through queriedItems to update or add new products
    //     queriedItems.forEach((newProduct) => {
    //       // console.log("newProduct:", newProduct);
    //       const existingProductIndex = this.products.findIndex(
    //         (product) => product.id === newProduct.id
    //       );
    //       // console.log("existingProductIndex:", existingProductIndex);

    //       if (existingProductIndex !== -1) {
    //         const existingProduct = this.products[existingProductIndex];

    //         if (existingProduct.updatedAt !== newProduct.updatedAt) {
    //           // Update the product while preserving thumbnailImages
    //           const updatedProduct = {
    //             ...newProduct,
    //             thumbnailImages: existingProduct.thumbnailImages,
    //           };
    //           this.products.splice(existingProductIndex, 1, updatedProduct);
    //         }
    //       } else {
    //         // If new product doesn't exist in this.products, add it
    //         this.products.push({
    //           ...newProduct,
    //           thumbnailImages: [],
    //         });
    //       }
    //     });

    //     // // Remove products not in sortedProducts
    //     this.products = this.products.filter((product) =>
    //       queriedItems.some((newProduct) => newProduct.id === product.id)
    //     );

    //     this.products = _.sortBy(this.products, [
    //       (p) => p.featured || false,
    //       (p) => new Date(p.publishDate),
    //       (p) => p.title,
    //     ]).reverse();
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.queriedProducts = true;
    //   }
    // },

    async syncData() {
      // console.log("Syncing data...DisplayProduct");
      try {
        // const currentRouteProductId = router?.currentRoute?.params?.productId;
        // this.syncProducts(currentRouteProductId);
        // this.syncProductBundles(currentRouteProductId);

        const tagSubscription = DataStore.observeQuery(ProductTag).subscribe(
          (snapshot) => {
            const { isSynced, items } = snapshot;
            if (
              // isSynced &&
              items?.length > 0
            ) {
              this.syncedProductTagArray = items;
            }
          },
          // (error) => {
          //     console.log("tagSubscription error: ", error);
          // }
        );

        const categorySubscription = DataStore.observeQuery(
          ProductCategory,
        ).subscribe(
          (snapshot) => {
            const { isSynced, items } = snapshot;
            if (
              // isSynced &&
              items?.length > 0 &&
              items !== this.syncedProductCategoryArray
            ) {
              const sortedItemsViaName = items.sort((a, b) =>
                a.name.localeCompare(b.name),
              );

              this.syncedProductCategoryArray = sortedItemsViaName;

              this.mainCategories = sortedItemsViaName.filter(
                (category) => !category.parentId,
              );

              //HIDE-subscription-17Jan2025-----------------------------------------------

              // const validGrades =
              //   this.syncedTeacherProfileModel?.payfastSubscriptionPackage
              //     ?.grades || [];

              // // Filter subjects where the grade is included in the validGrades array
              // const filteredCategories = items.filter((category) =>
              //   validGrades.includes(category.grade)
              // );

              // // Map the filtered subjects to their ids
              // const categoryIds = items.map((category) => category.id);

              // this.syncedSubscribedCategoryIDArray = categoryIds;

              //HIDE-subscription-17Jan2025-END-------------------------------------------
            }
          },
          // (error) => {
          //     console.log("categorySubscription error: ", error);
          // }
        );

        store.commit("addSubscriptions", [
          { model: "ProductTag", sub: tagSubscription },
          {
            model: "ProductCategory",
            sub: categorySubscription,
          },
        ]);
      } catch (error) {
        console.log(error);
      }
    },

    // syncProducts(currentRouteProductId) {
    //   console.log("currentRouteProductId", currentRouteProductId);
    //   const productSubscription = DataStore.observeQuery(Product, (p) =>
    //     p.id("eq", currentRouteProductId)
    //   ).subscribe(
    //     async (snapshot) => {
    //       const { isSynced, items } = snapshot;

    //       // console.log("syncProducts", isSynced, items);

    //       if (items) {
    //         this.syncedProductArray = items;
    //         // this.queryProductsAndBundles();

    //         if (
    //           typeof currentRouteProductId === "string" &&
    //           currentRouteProductId !== "" &&
    //           (!this.initiallyLoaded ||
    //             currentRouteProductId !== this.selectedProduct?.id) &&
    //           !this.selectingProduct &&
    //           items.some((product) => product.id === currentRouteProductId)
    //         ) {
    //           // console.log("selecting product: queryProducts");
    //           this.selectProduct(currentRouteProductId);
    //         }
    //       }

    //       if (isSynced) {
    //         this.syncedProducts = true;
    //       } else {
    //         this.syncedProducts = false;
    //       }
    //     }
    //     // (error) => {
    //     //     console.log("syncProducts error: ", error);
    //     // }
    //   );

    //   store.commit("addSubscription", {
    //     model: "Product",
    //     sub: productSubscription,
    //   });
    // },

    // syncProductBundles(currentRouteProductId) {
    //   const productBundleSubscription = DataStore.observeQuery(
    //     ProductBundle,
    //     (pb) => pb.id("eq", currentRouteProductId)
    //   ).subscribe(
    //     async (snapshot) => {
    //       const { isSynced, items } = snapshot;

    //       if (items) {
    //         this.syncedProductBundleArray = items;
    //         // this.queryProductsAndBundles();

    //         if (
    //           typeof currentRouteProductId === "string" &&
    //           currentRouteProductId !== "" &&
    //           (!this.initiallyLoaded ||
    //             currentRouteProductId !== this.selectedProduct?.id) &&
    //           !this.selectingProduct &&
    //           items.some((product) => product.id === currentRouteProductId)
    //         ) {
    //           // console.log("selecting product: queryProducts");
    //           this.selectProduct(currentRouteProductId);
    //         }
    //       }

    //       if (isSynced) {
    //         this.syncedProductBundles = true;
    //       } else {
    //         this.syncedProductBundles = false;
    //       }
    //     },
    //     (error) => {
    //       console.log(error);
    //     }
    //   );

    //   store.commit("addSubscription", {
    //     model: "ProductBundle",
    //     sub: productBundleSubscription,
    //   });
    // },
  },

  beforeDestroy() {
    store.commit("removeSubscriptions", ["ProductTag", "ProductCategory"]);

    store.commit("removeDatastorePredicates", [
      "ProductTag",
      "ProductCategory",
    ]);
  },
};
</script>
<style lang="scss">
/* Hiding scrollbar for Chrome, Safari and Opera */
#selectedProductThumbnails::-webkit-scrollbar {
  display: none;
}

/* Hiding scrollbar for IE, Edge and Firefox */
#selectedProductThumbnails {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.productsSearchInputCSS .v-input__slot {
  margin-bottom: 0px !important;
}

.productsSearchInputCSS .v-select__selections {
  min-height: 36px !important;
}

/* Table-specific styling */
.tiptap {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    max-width: 100% !important;
    width: auto !important;
    min-width: 200px !important;
    margin: 0;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }
  }

  li {
    p {
      margin-bottom: 0;
    }
  }

  ul {
    margin-bottom: 16px;
  }

  ol {
    margin-bottom: 16px;
  }
}

.tableWrapper {
  overflow-x: auto;
}
</style>
